import React, { Component } from 'react'
import Alert from 'react-bootstrap/Alert'

class ErrorPage extends Component {
    render() {
        return (
            <div style={{maxWidth:'400px', marginLeft:'auto', marginRight:'auto', marginTop: '200px', boxShadow: '0 15px 35px 0 rgba(0, 0, 0, 0.15)'}}>
                <Alert variant="danger">
                    <Alert.Heading>Somethings went wrong!</Alert.Heading>
                    <p>
                        We can not serve this site for you, sorry about this.
                    </p>
                    <hr />
                    <p className="mb-0">
                        Please come back again or check you site address, in minute!
                    </p>
                </Alert>
            </div>
        )
    }
}

export default ErrorPage
